var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"md-layout"},[_c('md-empty-state',{staticClass:"md-accent",attrs:{"md-icon":"warning","md-label":"505","md-description":"Url Expired"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }